var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaLaos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20332)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.75 0H-3.75V45H63.75V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.75 11.1846H-3.75V33.8158H63.75V11.1846Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3059 22.4999C20.3059 25.0708 21.3272 27.5365 23.1451 29.3544C24.963 31.1723 27.4287 32.1937 29.9996 32.1937C32.5706 32.1937 35.0362 31.1723 36.8541 29.3544C38.6721 27.5365 39.6934 25.0708 39.6934 22.4999C39.6934 19.929 38.6721 17.4633 36.8541 15.6454C35.0362 13.8275 32.5706 12.8062 29.9996 12.8062C27.4287 12.8062 24.963 13.8275 23.1451 15.6454C21.3272 17.4633 20.3059 19.929 20.3059 22.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaLaos);
export default __webpack_public_path__ + "static/media/la Laos.36be423b016e16eabffa443c647f1a6e.svg";
export { ForwardRef as ReactComponent };